module.exports = __webpack_public_path__ + "img/pub_rec_deets_960.0565cd95.png";